const Footer = () => {
  return (
    <footer style={{ backgroundColor: 'var(--bg-main2)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="/icon.png"
                alt="TrakStr Icon"
                className="h-8 w-8 mr-3"
              />
              <h3
                className="text-2xl font-bold"
                style={{ color: 'var(--text-main)' }}
              >
                TrakStr
              </h3>
            </div>
            <p className="mb-6 max-w-md" style={{ color: 'var(--text-main2)' }}>
              Self-hostable time tracking application with ActivityWatch
              integration. Privacy-focused solution for individuals who value
              data control.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://git.nostrdev.com/trakstr/trakstr-client"
                className="hover:opacity-80 transition-opacity"
                style={{ color: 'var(--text-main2)' }}
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
              <a
                href="#"
                className="hover:opacity-80 transition-opacity"
                style={{ color: 'var(--text-main2)' }}
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a
                href="#"
                className="hover:opacity-80 transition-opacity"
                style={{ color: 'var(--text-main2)' }}
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ color: 'var(--text-main)' }}
            >
              Product
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Installation
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Screenshots
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Roadmap
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ color: 'var(--text-main)' }}
            >
              Support
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Help Center
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Community
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--text-main2)' }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center"
          style={{ borderTop: '1px solid var(--border-color)' }}
        >
          <p className="text-sm" style={{ color: 'var(--text-main2)' }}>
            © 2024 TrakStr. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <a
              href="#"
              className="text-sm hover:opacity-80 transition-opacity"
              style={{ color: 'var(--text-main2)' }}
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-sm hover:opacity-80 transition-opacity"
              style={{ color: 'var(--text-main2)' }}
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
